import { SelectionContextProvider } from 'common/contexts/SelectionContext';
import * as React from 'react';
import { Divider } from '@mui/material';
import { HeaderLabel } from 'pages/Shipments/components';
import { InformationalTooltip } from 'components/InformationalTooltip';
import {
  WatchList,
  WatchListFilters,
  WatchlistQueryKeys,
  fetchWatchList,
} from 'services/clients/watchList';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Search } from '../Search';
import { ActionBar } from './ActionBar';
import { Table } from '../Table';
import { useDeletedWatchlistFilters, useTableColumns } from '../utilities';
import { getDeletedColumns } from '../Table/columns';

export const DeletedContainers: React.FC = () => {
  const filters: WatchListFilters = useDeletedWatchlistFilters();

  const shipmentsQuery: UseQueryResult<WatchList> = useQuery({
    queryKey: [WatchlistQueryKeys.Watchlist, filters],
    queryFn: ({ signal }) => fetchWatchList({ filters, signal }),
  });

  const { columns, showTooltip, setShowTooltip } = useTableColumns(getDeletedColumns);

  return (
    <SelectionContextProvider>
      <div className="flex flex-col h-full flex-shrink-0">
        <div>
          <div className="px-8 pt-8 space-y-4">
            <div className="flex gap-6 items-center">
              <div className="flex-shrink-0 flex items-center gap-2">
                <HeaderLabel className="text-text-accent-4">Deleted containers</HeaderLabel>
                <InformationalTooltip>
                  All of the containers you have removed from your watchlist. These containers are
                  not included in your reports.
                </InformationalTooltip>
              </div>
              <Search />
            </div>
            <Divider />
            <ActionBar />
          </div>
        </div>
        <div className="flex-grow">
          <Table
            shipmentsQuery={shipmentsQuery}
            columns={columns}
            setShowTooltip={setShowTooltip}
            showTooltip={showTooltip}
            variant="deleted"
          />
        </div>
      </div>
    </SelectionContextProvider>
  );
};
DeletedContainers.displayName = 'Shipments.DeletedContainers';
